import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import AddGroupChildrenItem from '../../../Domain/UserGroup/AddGroupChildrenItem';
import GroupHierarchyService from '../../../Services/UserGroup/GroupHierarchyService';

export default class AddGroupChildrenWindowDescription {
  static titleForCreate = 'Add Group Children';
  static titleForEdit = 'Add Group Children';
  static itemType = AddGroupChildrenItem;
  static serviceFunction = (item) => GroupHierarchyService.AddGroupChieldren(item);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'ChildGroupIds',
          label: 'Groups *',
          className: 'col-12',
          type: InputTypesEnum.ActiveGroupMultiChoice,
          validityChecker: ValidityHelper.forRequiredMultiSelectField,
        },
      ],
    },
  ];
}
